import React from 'react'
import CheckboxButton from 'LuxKit/Checkbox/CheckboxButton'
import ClickableListItem from 'LuxKit/List/ClickableListItem'

interface Props {
  isSelected?: boolean;
  onClick?: () => void;
}

function CruiseDepartureSelectListAll({ isSelected, onClick }: Props) {
  return <ClickableListItem
    onClick={onClick}
    title={<b>All departure ports</b>}
    endIcon={<CheckboxButton size="large" checked={isSelected} />}
  />
}

export default CruiseDepartureSelectListAll
